import { render, staticRenderFns } from "./Tabela-estatistica.vue?vue&type=template&id=63c683fb&scoped=true&"
import script from "./Tabela-estatistica.vue?vue&type=script&lang=js&"
export * from "./Tabela-estatistica.vue?vue&type=script&lang=js&"
import style0 from "./Tabela-estatistica.vue?vue&type=style&index=0&id=63c683fb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c683fb",
  null
  
)

export default component.exports